import { render } from "./BaseObjectIsUsedConfirmation.vue?vue&type=template&id=16aeee3c"
import script from "./BaseObjectIsUsedConfirmation.vue?vue&type=script&lang=js"
export * from "./BaseObjectIsUsedConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__